import Mailcheck from "mailcheck";
import Mail from "../class/Mail";
/**
* suggests a email of a given string
*/
const MailcheckerService = function (Config) {

  Mailcheck.domainThreshold = 3;
  Mailcheck.secondLevelThreshold = 3;
  Mailcheck.topLevelThreshold = 3;

  /**
   * @see https://github.com/mailcheck/mailcheck/issues/149
   * @param {string} email
   * @return {false|{topLevelDomain: string, secondLevelDomain: string, domain: string, address: string}}
   */
  Mailcheck.splitEmail = function (email) {
    var parts = email.trim().split('@');

    if (parts.length < 2) {
      return false;
    }

    for (var i = 0; i < parts.length; i++) {
      if (parts[ i ] === '') {
        return false;
      }
    }

    var domain = parts.pop();
    var domainParts = domain.split('.');
    var sld;
    var tld = '';

    if (domainParts.length === 0) {
      // The address does not have a top-level domain
      return false;
    } else if (domainParts.length === 1) {
      // The address has only a top-level domain (valid under RFC)
      sld = domainParts[ 0 ];
    } else {
      // The address has a domain and a top-level domain
      sld = domainParts[ 0 ];
      for (var r = 1; r < domainParts.length; r++) {
        tld += domainParts[ r ] + '.';
      }
      tld = tld.substring(0, tld.length - 1);
    }

    return {
      topLevelDomain: tld,
      secondLevelDomain: sld,
      domain: domain,
      address: parts.join('@')
    };
  };

  if (typeof mailcheckData === 'undefined') {
    mailcheckData = { domains: [], topLevelDomain: [], secondLevelDomain: [] };
  }

  return {
    mailcheckData: mailcheckData,
    checkOnCharCount: 2,
    suggestion: '',

    active: Config.email_suggestion_checkout,

    /**
     * sift4: https://siderite.blogspot.com/2014/11/super-fast-and-accurate-string-distance.html
     *
     * until Version 1.1.2 of npm-mailcheck is published
     * @see https://github.com/mailcheck/mailcheck/issues/147
     *
     * @param {string} s1
     * @param {string} s2
     * @param {number|undefined} maxOffset
     * @return {number}
     */
    sift4Distance: function (s1, s2, maxOffset) {
      if (maxOffset === undefined) {
        maxOffset = 5; //default
      }

      if (!s1 || !s1.length) {
        if (!s2) {
          return 0;
        }
        return s2.length;
      }

      if (!s2 || !s2.length) {
        return s1.length;
      }

      var l1 = s1.length;
      var l2 = s2.length;

      var c1 = 0; //cursor for string 1
      var c2 = 0; //cursor for string 2
      var lcss = 0; //largest common subsequence
      var local_cs = 0; //local common substring
      var trans = 0; //number of transpositions ('ab' vs 'ba')
      var offset_arr = []; //offset pair array, for computing the transpositions

      while ((c1 < l1) && (c2 < l2)) {
        if (s1.charAt(c1) === s2.charAt(c2)) {
          local_cs++;
          var isTrans = false;
          //see if current match is a transposition
          var i = 0;
          while (i < offset_arr.length) {
            var ofs = offset_arr[ i ];
            if (c1 <= ofs.c1 || c2 <= ofs.c2) {
              // when two matches cross, the one considered a transposition is the one with the largest difference in offsets
              isTrans = Math.abs(c2 - c1) >= Math.abs(ofs.c2 - ofs.c1);
              if (isTrans) {
                trans++;
              } else {
                if (!ofs.trans) {
                  ofs.trans = true;
                  trans++;
                }
              }
              break;
            } else {
              if (c1 > ofs.c2 && c2 > ofs.c1) {
                offset_arr.splice(i, 1);
              } else {
                i++;
              }
            }
          }
          offset_arr.push({
            c1: c1,
            c2: c2,
            trans: isTrans
          });
        } else {
          lcss += local_cs;
          local_cs = 0;
          if (c1 !== c2) {
            c1 = c2 = Math.min(c1, c2); //using min allows the computation of transpositions
          }
          //if matching characters are found, remove 1 from both cursors (they get incremented at the end of the loop)
          //so that we can have only one code block handling matches
          for (var j = 0; j < maxOffset && (c1 + j < l1 || c2 + j < l2); j++) {
            if ((c1 + j < l1) && (s1.charAt(c1 + j) === s2.charAt(c2))) {
              c1 += j - 1;
              c2--;
              break;
            }
            if ((c2 + j < l2) && (s1.charAt(c1) === s2.charAt(c2 + j))) {
              c1--;
              c2 += j - 1;
              break;
            }
          }
        }
        c1++;
        c2++;
        // this covers the case where the last match is on the last token in list, so that it can compute transpositions correctly
        if ((c1 >= l1) || (c2 >= l2)) {
          lcss += local_cs;
          local_cs = 0;
          c1 = c2 = Math.min(c1, c2);
        }
      }
      lcss += local_cs;
      return Math.round(Math.max(l1, l2) - lcss + trans); //add the cost of transpositions to the final result
    },

    /**
     *
     * @param {Mail} emailToCheck
     * @param {boolean} domains
     * @param {*|null} suggestedCallback
     * @param {*|null} emptyCallback
     */
    mailcheckRun: function (emailToCheck, domains, suggestedCallback, emptyCallback) {
      Mailcheck.run({
        email: emailToCheck.getMail(),
        domains: domains === false ? [] : this.mailcheckData.domains,
        topLevelDomains: this.mailcheckData.topLevelDomains,
        secondLevelDomains: this.mailcheckData.secondLevelDomains,
        distanceFunction: this.sift4Distance,
        suggested: suggestedCallback,
        empty: emptyCallback
      });
    },

    /**
     * @param {Mail} emailToCheck
     * @return {Mailchecker}
     */
    distanceCheck: function (emailToCheck) {
      var that = this;
      this.mailcheckRun(emailToCheck, false, function (suggestion) {

        var suggestedMail = Mailcheck.splitEmail(suggestion.full);

        if (suggestedMail.topLevelDomain !== '') {
          that.suggestion = suggestion.full;
        } else {
          // no topdomain given => so we find a suggestion with a topleveldomain
          var suggestionMail = new Mail(suggestion.full + '.' + that.mailcheckData.topLevelDomains[ 0 ]);
          that.suggestion = suggestionMail.getMail();

          that.mailcheckRun(suggestionMail, false, function (suggestionWithTld) {
            that.suggestion = suggestionWithTld.full;
          }, function () {
            // nothing found -> check email with the domains
            that.mailcheckRun(suggestionMail, true, function (suggestionWithTld) {
              that.suggestion = suggestionWithTld.full;
            });
          });

        }
      }, function () {
        that.resetSuggestion();

        // nothing found -> check email with the domains
        that.mailcheckRun(emailToCheck, true, function (suggestionWithTld) {
          that.suggestion = suggestionWithTld.full;
        });
      });
      return this;
    },

    /**
     * @param {Mail} mail
     * @return {boolean} - have a completion
     */
    completion: function (mail) {
      for (var i = 0; i < this.mailcheckData.domains.length; i++) {
        var domain = this.mailcheckData.domains[ i ];
        if (mail.mailData && domain.length !== mail.mailData.domain.length && domain.indexOf(mail.mailData.domain) === 0) {
          this.suggestion = mail.mailData.address + '@' + domain;
          return true;
        }
      }

      return false;
    },

    /**
     * @param {string} emailToCheck
     * @return {Mailchecker}
     */
    check: function (emailToCheck) {
      if (!this.active) {
        return this;
      }

      var mail = new Mail(emailToCheck);
      if (!mail.mailData || !mail.mailData.domain || mail.mailData.domain.length < this.checkOnCharCount) {
        return this;
      }

      for (var i = 0; i < this.mailcheckData.topLevelDomains.length; i++) {

        var topLevelDomain = this.mailcheckData.topLevelDomains[ i ];
        mail.transform(topLevelDomain);
      }

      if (!this.completion(mail)) {
        this.distanceCheck(mail);
        if ('' === this.suggestion && mail.changed) {
          this.suggestion = mail.getMail();
        }
      }
      return this;
    },

    resetSuggestion: function () {
      this.suggestion = '';
    },

    /**
     * @return {string}
     */
    useSuggestion: function () {
      var used = this.suggestion;
      this.resetSuggestion();
      return used;
    }
  };
};

export default MailcheckerService;